/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Project_Loaded_MessageInputs */



/**
* | output |
* | --- |
* | "Project loaded successfully" |
*
* @param {Iframe_Remote_Project_Loaded_MessageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_project_loaded_message = /** @type {((inputs?: Iframe_Remote_Project_Loaded_MessageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Project_Loaded_MessageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Projet charge avec succes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projekt erfolgreich geladen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Progetto caricato correttamente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Проект успешно загружен.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Proyecto cargado exitosamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("项目加载成功")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトが正常に読み込まれました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोजेक्ट सफलतापूर्वक लोड हो गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Projeto carregado com sucesso")
	return /** @type {LocalizedString} */ ("Project loaded successfully")
});